/* eslint-disable import/no-anonymous-default-export */

// Tipos de usuários do sistema
const EUserTypes = {
  PANEL_ADMIN: {
    code: 1,
    description: 'Administrador do Painel',
    label: 'Admin'
  },
  CLIENT_ADMIN: {
    code: 2,
    description: 'Administrador do Cliente',
    label: 'Admin Cliente'
  },
  EMPLOYEE: {
    code: 3,
    description: 'Funcionário',
    label: 'Funcionário'
  },
  ORIGINAL_CLIENT: {
    code: 4,
    description: 'Cliente Original',
    label: 'Cliente'
  },
};

export default EUserTypes;


